import Tabs from "../tabs";
import { addTrail } from "../trail";
/**
 * Saves an ixcanul file to the database using the save backend API
 * @param {Object} node an object representing a node on the file tree or the required fields in the save api
 * @param {String} filename title of the saved file.
 * @param {String} content the new content of the saved file.
 * @param {Boolean} rename is this a rename for the file?.
 * @param {String} orgTitle the old filename for matching during a savefile.
 */
export default function(node, filename, content, rename, orgTitle) {
  orgTitle = typeof orgTitle !== "undefined" ? orgTitle : null;
  let url;
  let isNewFile = node.key == "";
  let renamingFile = typeof rename !== "undefined" ? rename : null;
  let fileType = CodeEditor.Main.fileType(node);
  let extension = node.title.split(".")[node.title.split(".").length - 1];
  let reference = CodeEditor.Main.generateReference(node, filename, fileType);
  let path = CodeEditor.Main.generatePath(node, filename);
  let method = isNewFile ? "post" : "PATCH";
  let isUploading = isNewFile && content.length;
  let notification = CodeEditor.UI.notif({
    id: "savingFile_" + node.data.secure_random,
    message: "saving..",
    timeout: 100000,
    progressBar: false,
    position: "bottomLeft"
  });
  if (CodeEditor.Main.mode(node) === "tephra") {
    url = "/api/v1/tephra_snippets/" + node.data.secure_random + "/save";
  } else if (method == "post") {
    url = "/api/v1/code_editor";
  } else {
    url = "/api/v1/code_editor/" + node.data.secure_random;
  }
  const settings = node.data.settings;
  if (settings) {
    extension = "json";
    url = url = "/api/v1/tephra_snippets/" + node.data.secure_random + "-json/save";
  }
  return $.ajax({
    url: url,
    type: method,
    headers: {
      "x-csrf-token": $("meta[name='csrf-token']").attr("content")
    },
    data: {
      path: path,
      reference: reference,
      file_type: fileType,
      content: content,
      extension: extension,
      upload: /^(images|fonts)\//.test(reference),
      rename: renamingFile,
      folder: node.folder,
      theme_id: CodeEditor.Main.themeId(),
      socket_id: window.socketId,
      design_mode: true,
      variations_attributes: node.data.variations_attributes
    },
    beforeSend: function() {
      window.selectedNodeAvailable = false;
      addTrail(`Saving "${reference}"`);
      return true;
    },
    success: function(data) {
      window.selectedNodeAvailable = true;
      if (data.success === true) {
        let notiConfig = {
          replace: true,
          id: `savingFile_${node.data.secure_random}`,
          message: `${reference} saved successfully`,
          timeout: 1000
        };
        addTrail(`Saved "${reference}" successfully`);
        notification.success(notiConfig);
        if (!isNewFile && rename != true) {
          let savedTab = Tabs.getTabByKey(data.key) || Tabs.getTabByKey(node.data.secure_random);
          if (savedTab) {
            console.warn(savedTab);
            $('[tab_key="' + savedTab.config.secure_random + '"],[tab_key="' + node.data.secure_random + '"]').attr(
              "class",
              "file_save save_success"
            );
            // Tabs.getActiveTabHeader().find('.file_save').attr('class', 'file_save save_success');
            savedTab = Object.assign(savedTab, data);
          }
          if (aceSessions["session_" + node.key] !== undefined) {
            aceSessions["session_" + data.key] = aceSessions["session_" + node.key];
            if (node.data.settings && data.variations) {
              const variations = data.variations.map(i => JSON.parse(i.content));
              const value = JSON.stringify(variations, 2, "\t");
              aceSessions["session_" + data.key].setValue(value);
            }
          }
          if (selectedNode === null) {
            selectedNode = CodeEditor.Tree.selectNode(data.key);
          }
        } else if (isNewFile) {
          notification.success($.extend(notiConfig, { message: `${reference} added successfully` }));
        }
        if (CodeEditor.Main.mode(node) === "tephra") {
          if (node.data.variations_attributes && data.variations) {
            node.data.variations_attributes = data.variations;
          }
          node.key = String(data.key);
          return true;
        }
        // we need update the node when the file
        // is created or renamed.
        node.key = String(data.key);
        node.title = data.title;
        node.data.reference = data.reference;
        node.data.path = data.path;
        node.data.file_type = data.file_type;
        node.data.secure_random = data.secure_random;
        node.extraClasses = data.folder ? "" : "file";
        CodeEditor.Main.orderFoldersFirst(window.tree.getRootNode(), null, true);
        // Update children path if a folder has been renamed
        if (renamingFile && node.folder) {
          CodeEditor.Main.updatePaths(node);
        }
        /* Pass the newly created node to parent to process it */
        if (isNewFile && isUploading) {
          typeof node.parent.notify === "function" && node.parent.notify(node);
        }
        return true;
      }
      let unsavedTab = Tabs.getTabByKey(data.key);
      if (unsavedTab) {
        Tabs.getActiveTabHeader()
          .find(".file_save")
          .attr("class", "file_save save_failed");
      }
      if (renamingFile) {
        node.setTitle(orgTitle);
      }
      if (node.key === "") {
        node.remove();
      }
      notification.destroy($("#savingFile_" + node.data.secure_random)[0], { transitionOut: "fadeOut" });
      CodeEditor.UI.notif.error({
        message: "ERR:: " + data.message
      });
      addTrail(`ERR:: did not save "${reference}"`);
      return true;
    },
    error: function(xhr, ajaxOptions, thrownError) {
      window.selectedNodeAvailable = true;
      Tabs.getActiveTabHeader()
        .find(".file_save")
        .attr("class", "file_save save_failed");
      notification.error($("#savingFile_" + node.data.secure_random)[0], { transitionOut: "fadeOut" });
      CodeEditor.UI.notif.error("ERR:: " + thrownError);
      addTrail(`ERR:: did not save "${reference}"`);
    }
  });
}
